var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "currentColor",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.139 1.457c.344 0 .622.282.622.63v3.32a.626.626 0 0 1-.622.631.627.627 0 0 1-.623-.63v-3.32c0-.349.279-.631.623-.631Zm5.853 0c.344 0 .623.282.623.63v3.32a.627.627 0 0 1-.623.631.626.626 0 0 1-.623-.63v-3.32c0-.349.28-.631.623-.631ZM3.972 7.4c0-.348.278-.63.622-.63h12.81c.344 0 .623.282.623.63 0 .348-.279.63-.623.63h-.528c.172 2.772-.513 4.751-1.627 6.066a5.574 5.574 0 0 1-3.574 1.945v3.87c0 .349-.279.63-.623.63a.626.626 0 0 1-.622-.63v-3.856a5.398 5.398 0 0 1-3.592-1.916C5.726 12.82 5.042 10.825 5.185 8.03h-.59a.627.627 0 0 1-.623-.63Zm2.46.63c-.145 2.594.49 4.267 1.353 5.29.93 1.101 2.186 1.526 3.252 1.499h.015c1.047 0 2.316-.44 3.252-1.544.865-1.021 1.5-2.679 1.324-5.245H6.432Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.527.916h14.946v20.167H3.527z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnector);
export default __webpack_public_path__ + "static/media/connector.91f52d0788e3af9167b5d45ca67fe1da.svg";
export { ForwardRef as ReactComponent };